const ServicioURLManager = (() => {
    async function getUrlServicios(callback: Function) {
      try {
        const serverLocal = localStorage.getItem('serverlocalhost');
        if (serverLocal === "S") {
          const localApiUrl = "http://api.test:8080";
          callback([{ Url: localApiUrl }]);
        } else {
          const remoteUrl = await fetchRemoteApiUrl_v2();
          callback([{ Url: `https://${remoteUrl[0].Url}` }]);
        }
      } catch (ex) {
        console.error("Error en getUrlServicios:", ex);
        callback(null, ex);
      }
    }
  
    async function fetchRemoteApiUrl_v2() {
      try {
        return await _fetchApiActive_v2();
      } catch (ex) {
        console.error("Error en fetchRemoteApiUrl_v2:", ex);
        throw ex;
      }
    }
  
    function _fetchApiActive_v2() {
      return new Promise((resolve) => {
        apiActive_v2(resolve);
      });
    }
  
    function apiActive_v2(callback: Function) {
      try {
        callback([{ Url: 'api.bestroute.io' }]); // Simulación de API activa
      } catch (ex) {
        console.error("Error en apiActive_v2:", ex);
      }
    }
  
    return {
      getUrlServicios,
    };
  })();
  
  export default ServicioURLManager;
  